'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'truck-fast';
var width = 640;
var height = 512;
var aliases = ["shipping-fast"];
var unicode = 'f48b';
var svgPathData = 'M80 16l320 0 0 384-163.3 0c-10.4-36.9-44.4-64-84.7-64c-29.8 0-56.1 14.8-72 37.4L80 288l-16 0 0 112 0 16 .4 0c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8L400 416l.4 0c-.2 2.6-.4 5.3-.4 8c0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8l56.4 0 8 0 0-16-8 0-24 0 0-184 0-3.3-2.3-2.3-112-112L491.3 96 488 96l-72 0 0-80 0-16L400 0 80 0 64 0l0 16 0 80L8 96 0 96l0 16 8 0 208 0 8 0 0-16-8 0L80 96l0-80zM416 216l0-104 68.7 0 104 104L416 216zm0 16l176 0 0 168-19.3 0c-10.4-36.9-44.4-64-84.7-64c-29.8 0-56.1 14.8-72 37.4L416 232zM80 424a72 72 0 1 1 144 0A72 72 0 1 1 80 424zm408-72a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM40 160l-8 0 0 16 8 0 240 0 8 0 0-16-8 0L40 160zM8 224l-8 0 0 16 8 0 208 0 8 0 0-16-8 0L8 224z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTruckFast = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;